import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import Cookies from 'js-cookie'
import {
  VueAxios
} from './axios';
import {
  params
} from '@/config';
import {
  message
} from 'ant-design-vue';
import notification from 'ant-design-vue/es/notification';
const Qs = require("querystring");
Vue.use(message);

// 创建 axios 实例
const service = axios.create({
  timeout: 20000, // 请求超时时间
});

// 错误处理、
const err = (error) => {
  if (error.response) {
    const {
      errcode,
    } = error.response;
    if (errcode != 0) {
      notification.error({
        message: error.response.errmsg,
        duration: 1
      });
      store.commit('SET_TOKEN_ERROR', true);
      store.dispatch('Logout');
    }
  }
  return Promise.reject(error.response)
};

// request 拦截器
service.interceptors.request.use(config => {
  let pms = Qs.parse(Qs.stringify(params))
  config.method == "post" ?
    (config.data = Object.assign(pms, config.data)) :
    (config.url += '?' + Qs.stringify(Object.assign({}, config.data)));

  // 设置token
  const token = Cookies.get('token');
  if (token) {
    config.headers['Authorization'] = "Bearer " + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }

  return config
}, err)


// response 拦截器
service.interceptors.response.use((response) => {
  const {
    data
  } = response;
  if (data.errcode == 403) {
    alert(data.errmsg)
  }

  return data;
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}